var React = require('react');

function Fail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M48.5 25C48.5 37.9787 37.9787 48.5 25 48.5C12.0213 48.5 1.5 37.9787 1.5 25C1.5 12.0213 12.0213 1.5 25 1.5C37.9787 1.5 48.5 12.0213 48.5 25ZM50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25ZM24.1092 30.4268H25.9412L26.7143 12H23.3361L24.1092 30.4268ZM23.5714 33.9691C23.1905 34.3065 23 34.8823 23 35.6966C23 36.4993 23.1905 37.0868 23.5714 37.4591C23.9524 37.8197 24.4286 38 25 38C25.5602 38 26.0308 37.8197 26.4118 37.4591C26.8039 37.0868 27 36.4993 27 35.6966C27 34.8823 26.8039 34.3065 26.4118 33.9691C26.0308 33.6201 25.5602 33.4456 25 33.4456C24.4286 33.4456 23.9524 33.6201 23.5714 33.9691Z","fill":"#F3BE00"}));
}

Fail.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = Fail;

Fail.default = Fail;
